// para obtener todos los clientes
export const GET_SHARED_TOKEN_SUCCESS = 'GET_SHARED_TOKEN_SUCCESS';
export const GET_SHARED_TOKEN_FAIL = 'GET_SHARED_TOKEN_FAIL';
// para obtener el beneficiario por busqueda    
export const GET_TOKEN_SEARCH_SUCCESS = 'GET_TOKEN_SEARCH_SUCCESS';
export const GET_TOKEN_SEARCH_FAIL = 'GET_TOKEN_SEARCH_FAIL';